/** Construct a typed unit of a given dimension */
export const unit = (val) => val;
/** Sum a serie of similarly dimensionned units */
export const sumUnits = (...val) => unit(val.reduce((a, b) => a + b, 0));
export const subUnits = (val1, val2) => unit(val1 - val2);
/** Multiply a unit by a scalair */
export const multUnit = (u, l) => unit(u * l);
/** Average a serie of similarly dimensionned units */
export const avgUnits = (...val) => multUnit(sumUnits(...val), 1 / val.length);
//# sourceMappingURL=operations.js.map